// extracted by mini-css-extract-plugin
module.exports = {"commentList":"_1ugCa","separator":"_2qZ5Q"};